import React, { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'

import './styles.css'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)
